/** @import modules */

import { useTranslation }   from "react-i18next";

import { useQuery }         from "@apollo/client";

/** @import queries */

import { LEGAL_DATA, WORKING_HOURS } from "../Queries/Contacts";

import { buildCategoryPath } from "../Misc/Permalinks";

import {
    localizedPath,
    normalizeLanguage
}                           from "../Components/SEO/localizedMeta";

/** @import components */

import Copyrights           from "../Components/Layout/Footer/Copyrights";

import FooterInfo           from "../Components/Layout/Footer/Information";

import Gateway              from "../Components/Layout/Footer/Gateway";

import FooterNavigation     from "../Components/Layout/Footer/Navigation";

import Socials              from "../Components/Layout/Footer/Social";

import Salidzini            from "../Components/Layout/Footer/Salidzini";

// import Subscription         from "../Components/Layout/Footer/Subscription";

/** Get country code from domain TLD (e.g. tireshop.lv -> LV) */
const getCountryCodeFromDomain = () => {
    if ( typeof window === "undefined" ) return null;
    const tld = window.location.hostname.split( "." ).pop().toLowerCase();
    return tld;
};

/** Register datasets */

const FooterDatasets = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage ( i18n?.resolvedLanguage || i18n?.language ),

    categoryRoute = productType => localizedPath ( buildCategoryPath ( productType ), currentLanguage ),

    { data: legalData, loading } = useQuery(LEGAL_DATA, {
        variables: { countryCode: getCountryCodeFromDomain() }
    }),

    { data: workingHoursData, loading: loadingWorkingHours } = useQuery(WORKING_HOURS);

    /** Contacts */

    const ld = legalData?.legalData;

    const formatClock = ( time ) => {

        if ( ! time || typeof time !== "string" ) return null;

        return time.replace ( "-", ":" );

    },

    formatRange = ( start, end ) => {

        if ( ! start || ! end || ( start === "00-00" && end === "00-00" ) ) {

            return t ( "closed" );

        }

        const from = formatClock ( start );

        const to = formatClock ( end );

        if ( ! from || ! to ) return t ( "closed" );

        return `${ from } - ${ to }`;

    },

    wh = workingHoursData?.workingHours,

    Contacts = [

        {

            name        : t ( "weekdays" ),

            content     : ( loadingWorkingHours ) ? `${ "loading" }...` : formatRange ( wh?.startTimeMonday, wh?.endTimeMonday ),

            display     : "default",
        
            link        : false,
        
            URI         : null },

        {

            name        : t ( "saturday" ) + ":",

            content     : ( loadingWorkingHours ) ? `${ "loading" }...` : formatRange ( wh?.startTimeSaturday, wh?.endTimeSaturday ),

            display     : "default",
        
            link        : false,
        
            URI         : null },

        {

            name        : t ( "sunday" ) + ":",

            content     : ( loadingWorkingHours ) ? `${ "loading" }...` : formatRange ( wh?.startTimeSunday, wh?.endTimeSunday ),

            display     : "default",
        
            link        : false,
        
            URI         : null },

        {

            name        : t ( "call" ),

            content     : ( loading ) ? `${ "loading" }...` : ( ld?.phone ?? "-" ),

            display     : "default",
        
            link        : true,
            
            external    : true,

            action      : true,

            URI         : ( loading ) ? "#" : `tel:${ ld?.phone ?? "" }` },

        {

            name        : t ( "service_number" ),

            content     : ( loading ) ? `${ "loading" }...` : ( ld?.servicePhone ?? "-" ),

            display     : "default",
        
            link        : true,
            
            external    : true,

            action      : true,

            URI         : ( loading ) ? "#" : `tel:${ ld?.servicePhone ?? "" }` },

        {

            name        : t ( "write" ),

            content     : ( loading ) ? `${ "loading" }...` : ( ld?.email ?? "-" ),

            display     : "accented",
        
            link        : true,
            
            external    : true,

            action      : true,

            URI         : ( loading ) ? "#" : `mailto:${ ld?.email ?? "" }` }

    ],

    /** Location */

    Location = [

        {

            name        : t ( "address" ),

            content     : ( loading ) ? `${ "loading" }...` : ( ld?.factualAddress ?? "-" ),

            link        : false,

            URI         : null,

            external    : false,

            action      : false,
        
            display     : "default" },

        { 
            
            name        : "Waze:", 
        
            content     : t ( "use_waze" ), 
        
            link        : true, 

            external    : true,

            action      : false,
        
            URI         : "https://ul.waze.com/ul?place=ChIJU7oCGgDS7kYRWG5njTFSuJI&ll=56.92684850%2C24.18595930&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
        
            display     : "default" }

    ],

    /** Policies routes */

    Policies = [

        { route: "/policies/privacy-policy",        name: t ( "privacy_policy" )            },

        { route: "/policies/cookie-policy",         name: t ( "cookies" )                   },

        { route: "/policies/terms-of-use",          name: t ( "terms_and_conditions" )      }

    ],

    Contents = [

        { route: "/content/about",                  name: t ( "about_us" )                  },

        { route: "/content/delivery",               name: t ( "delivery_information" )      },

        { route: "/content/payments",               name: t ( "payments" )                  },

        // { route: "/content/collaboration",          name: t ( "collaboration" )             },

        { route: `/content/technical-information`,               name: t ( "technical_info" )                  },

        { route: "/blog",                           name: t ( "blog" )                      },

        // { route: "/content/gallery",                name: t ( "gallery" )                   }

    ],

    Shop = [

        { route: categoryRoute ( "tire" ),            name: t ( "tyres" )                     },

        { route: categoryRoute ( "rim" ),             name: t ( "rims" )                      },

        { route: categoryRoute ( "battery" ),        name: t ( "batteries" )                 },

        { route: `/content/services`,               name: t ( "services" )                  },

        { route: "/content/montage",                name: t ( "montage" )                   },

        // { route: "/shop/sale",                      name: t ( "sale" )                      }

    ];

    /** Footer panes */

    return [

        { render: [

            // {   content: <Subscription />, 
            
            //     id: "subscribe" },

            {   content: <Gateway />, 
            
                id: "gateway" },

            {   content: <Salidzini />, 
            
                id: "salidzinilv" },

            {   content: <Copyrights />, 
            
                id: "copyrights" }

        ] },

        { render: [

            {   content: <FooterInfo 
                
                    data={ Contacts } />, 
                
                id: "contacts" },

            {   content: <FooterInfo 
                
                    data={ Location } />, 
                
                id: "location" },

            {   content: <Socials />, 
                
                id: "socials" }
                
        ] },

        { render: [ 
            
            {   content: <FooterNavigation 
            
                    routes={ Shop } />, 
                
                id: "shop" } ] },

        { render: [ 
            
            {   content: <FooterNavigation 
            
                    routes={ Contents } />, 
                
                id: "contents" } ] },

        { render: [ 
            
            {   content: <FooterNavigation 
            
                    routes={ Policies } />, 
                
                id: "policies" } ] },

    ];



}

/** Export datasets */

export default FooterDatasets;